import { useEffect, useRef, useState} from 'react'

import { showLoading } from 'services/util'
import { history } from 'services/history.js'

import { urlQueryParser } from 'services/util'
import { getPublicAuctionDetail, registerUserForAuction } from '../../api'
import { getImageUrl } from 'sites/auctions/util/images'
import CustomMarkdown from 'sites/auctions/components/CustomMarkdown'
import { getAuctionStatus } from '../../util/dateString'
import PreviewAuctionHeader from '../../admin/PreviewAuctionHeader'

import css from '../sass/flow.module.scss'
import auctionCss from '../../auctions/sass/auctions.module.scss'
import themeCss from '../../components/sass/theme.module.scss'
import { HeaderGradient } from 'common/header/HeaderStyles'
import ItemCardBrowse from '../../items/ItemCardBrowse'
import { getItemsInDisplayOrder } from '../../components/utils'


export default function AuctionFromEmail(props) {
  const [auctionDetail, setAuctionDetail] = useState()
  const [userExists, setUserExists] = useState(false)
  const [imageUrl, setImageUrl] = useState()
  const [status, setStatus] = useState()
  const [displayItems, setDisplayItems] = useState([])
  const itemsSectionRef = useRef(null)

  const {
    auctionId: auctionCode,
    publicId,
    email,
    isPreview,
  } = urlQueryParser(props.location.search)
  
  // have to reload page to get themeHeader to pick up new sessionStorage value
  if (isPreview === 'true') {
    sessionStorage.setItem('proxyHeaderVisible', true)
    sessionStorage.setItem('previewAuctionCode', auctionCode)
    history.push({ pathname: '/flow/auction', search: `?auctionId=${auctionCode}`})
    window.location.reload()
  }

  if (email) localStorage.setItem('savedUsername', email)
  localStorage.setItem('savedAuctionCode', auctionCode)

  useEffect(() => {
    if (!auctionCode)
      return

    showLoading(true)

    const getDetails = async () => {
      const {success, error} = await getPublicAuctionDetail(auctionCode, publicId, email)
      console.log({success, error})
      showLoading(false)

      if (error || !success || !success.auction || success.auction.error) {
        console.log('Error!', error ||  success?.auction?.error || "No auction found")
      }
      else if (success.auction) {
        setAuctionDetail(success.auction)
        if (sessionStorage.previewAuctionCode) sessionStorage.setItem('previewAuctionId', success.auction.AuctionId)
        setUserExists(success.userExists)
      }
    }

    getDetails()

  }, [auctionCode, publicId, email])

  // use effect for auction banner image
  useEffect(() => {
    if (!auctionDetail)
      return

    setStatus(getAuctionStatus(auctionDetail?.StartTime, auctionDetail?.EndTime))

    const url = getImageUrl(auctionDetail?.AuctionCode, 'banner', auctionDetail?.BannerImageName)
    setImageUrl(url)
  }, [auctionDetail])

  useEffect(() => {
    if (!auctionDetail) return

    setDisplayItems(getItemsInDisplayOrder({ auction: auctionDetail }))
  }, [auctionDetail])

  const doSignin = async (e) => {
    e.preventDefault()

    if (sessionStorage.previewAuctionCode) {
      showLoading(true)
      const signUpResponse = await registerUserForAuction(auctionDetail.AuctionCode)
      showLoading(false)
      history.push({pathname: '/auctionhome', search: 'auctionId=' + auctionDetail.AuctionCode})
    }
    else {
      history.push({pathname: userExists || localStorage.savedAuctionCode ? '/signin' : '/registration'})
    }
  }

  const scrollToItems = () => {
    itemsSectionRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }

  if (!auctionDetail)
    return <p>Auction Not Found</p>

  // assign variable to allow for undefined or null values from auctions where the value is not assigned, defaulting to true
  const showAuctionItems = auctionDetail.AllowVisitorView === false ? false : true

  return (
    <>
      <PreviewAuctionHeader />
      <HeaderGradient />
      <div className={css['auction-email-container']}>
        <h1 id="landingPageTitle">{auctionDetail.Title}</h1>
        <div className={themeCss['blue-background']}>

{/* TO DO: after comps updated, need to make 16x9 */}
          {imageUrl ?
            <img className={css['auction-email-banner']} src={`${imageUrl}`} alt={'Auction Banner'} />
           :
           <p className={css['auction-email-banner-undefined']}>No auction image saved, need to upload one inside Admin panel.</p>
          }

          {status !== 'ended' &&
            <div className={css['landing-buttons-container']}>
              <p>Join the auction and support our cause!</p>
              <button
                onClick={doSignin}
                className={`${themeCss['FilledYellow']} ${themeCss['button']}`}>Sign In For Auction
              </button>
              {auctionDetail.AllowVisitorView === true && <button className={`${themeCss['FilledWhite']} ${themeCss['button']}`}
                  onClick={scrollToItems}> View Items </button>}
            </div>}

          <CustomMarkdown text={auctionDetail.Description} cssClass={css['auction-email-description']} />

          <div ref={itemsSectionRef} className={`${auctionCss['auctionitems-container']} ${css['auctionitems-center']}`}>

            {/* for non registered viewers of the auction: */}
            {showAuctionItems && displayItems && displayItems.map((item) => {
              return <ItemCardBrowse key={item.ItemId || item.FixedItemId} item={item} auction={auctionDetail} />
            })}
          </div>

          {showAuctionItems && status !== 'ended' &&
            <div className={css['landing-buttons-container']}>
              <p>Join the auction and support our cause!</p>
              <button
                onClick={doSignin}
                className={`${themeCss['FilledYellow']} ${themeCss['button']}`}>Sign In For Auction
              </button>
            </div>}

        </div>
      </div>
    </>
  )
}
